/// <amd-module name="Favorites/Star/FavoritesStarButton" />
import * as FavoritesResources from "Favorites/Common/Resources";
import * as React from "react";
import { VssComponent } from "VSS/Platform/Layout";
import { Button } from "VSSUI/Button";
import { css } from "VSSUI/Util";

export interface IFavoritesStarButtonProps {
    isFavorited: boolean;

    className?: string;

    buttonClassName?: string;
    /**
     * Favorited aria-label
     */
    favoritedArialabel?: string;

    /**
     * UnFavorited aria-label
     */
    unFavoritedArialabel?: string;

    onToggleFavorite: (event: React.MouseEvent<any>) => void;
}

export class FavoritesStarButton extends React.Component<IFavoritesStarButtonProps> {
    public static componentType = "favoritesStarButton";

    public render(): JSX.Element {
        const { isFavorited, buttonClassName, className, onToggleFavorite } = this.props;

        const tooltipText = isFavorited ? FavoritesResources.FavoriteStarFavoritedTitle : FavoritesResources.FavoriteStarUnfavoritedTitle;
        const ariaLabel = isFavorited ? this.props.favoritedArialabel : this.props.unFavoritedArialabel;

        const iconProps = {
            iconName: isFavorited ? "FavoriteStarFill" : "FavoriteStar",
            className: css(className, isFavorited ? "vss-FavoriteItem--starIcon favorited" : "vss-FavoriteItem--starIcon")
        };

        return (
            <Button
                subtle={true}
                iconProps={iconProps}
                onClick={onToggleFavorite}
                ariaLabel={ariaLabel ? ariaLabel : tooltipText}
                aria-pressed={isFavorited}
                className={buttonClassName}
                tooltipProps={{ showOnFocus: true, text: tooltipText }}
            />
        );
    }
}
VssComponent.register(FavoritesStarButton.componentType, FavoritesStarButton);
